/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
} from '../../../services/settings/appStyle/global.style';
import {
  Table,
  IconButton as IconButtonWithText,
  Label,
  Loader,
} from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import LogbookService from '../../../services/bioplus-services/logBook';
import DocumentService from '../../../services/bioplus-services/document';
import DateUtils from '../../../utils/date-utils';
import { FilterMenuFieldV2 } from '../../../Components/uielements/filterMenuField';
import { extractData, getDeclarationQuestions } from './logHelper';
import { DownloadIcon, EyeIcon } from '../../../Components/icons';
import { useCompany } from '../../../hooks/CompanyContext';
import moment from 'moment';
import DeclarationModal from './declarationModalView';
import { IntlMessages } from '../../../helper/langHelper';
import { useIntl } from 'react-intl';
import { exportExcelFile } from '../../../helper/exportExcelHelper';

const CorporateLogRecords = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();

  const parentId = userContext?.company?.companyId?.id;
  const companyFilter = companyContext?.company?._id;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState(DateUtils.last7Days);
  const [endDate, setEndDate] = useState(DateUtils.today);
  const [isDeclarationView, setIsDeclarationView] = useState(false);
  const [declarationData, setDeclarationData] = useState();
  // format language
  const intl = useIntl();
  const alertMessagedeclarationFailed = intl.formatMessage({
    id: 'help.text.declaration.error',
  });

  const query = useQuery(
    ['logBookEntries', parentId, companyFilter, startDate, endDate, page, pageSize],
    () =>
      LogbookService.listByParent(
        parentId,
        {
          companyId: companyFilter,
          fromDate: startDate,
          toDate: endDate,
        },
        page,
        pageSize
      )
  );
  const tableData = query?.data?.items ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  const handleFilterParams = (filterParams) => {
    if (filterParams) {
      const { fromDate, toDate } = filterParams;
      setStartDate(fromDate);
      setEndDate(toDate);
    }
  };

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.visitor.name" />,
        accessor: 'userName',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.company" />,
        accessor: 'companyName',
        width: '18%',
      },
      {
        Header: <IntlMessages id="table.col.premise" />,
        accessor: 'premiseName',
      },
      {
        Header: <IntlMessages id="table.col.zone" />,
        accessor: 'geofenceName',
        width: '8%',
      },
      {
        Header: <IntlMessages id="table.col.service.role" />,
        accessor: 'serviceRole',
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.entry.date" />,
        accessor: 'entryDate',
        Cell: (cellData) => <TableCell>{moment(cellData.value).format('DD-MM-YYYY')}</TableCell>,
        width: '15%',
        id: 'entryDate',
      },
      {
        Header: <IntlMessages id="table.col.entry.time" />,
        accessor: 'entryDate',
        Cell: (cellData) => <TableCell>{moment(cellData.value).format('hh:mm:ss A')}</TableCell>,
        width: '15%',
        id: 'entryTime',
      },
      {
        Header: <IntlMessages id="table.col.exit.time" />,
        accessor: 'exitDate',
        width: '15%',
        Cell: (cellData) => <TableCell>{moment(cellData.value).format('hh:mm:ss A')}</TableCell>,
      },
      {
        Header: <IntlMessages id="text.declaration" />,
        accessor: 'declaration',
        isAction: true,
        width: '15%',
      },
    ],
    []
  );

  const handleDeclarationLink = async (data) => {
    try {
      const content = await DocumentService.getDocument(data?.declarationId);
      const declarationContent = {
        ...content,
        geofenceName: data?.geofenceName,
      };
      if (content && declarationContent) {
        // const declarationQuestionAnswer = getDeclarationQuestions(declarationContent);
        // if (declarationQuestionAnswer) {
        setDeclarationData(declarationContent);
        setIsDeclarationView(true);
        // }
      }
    } catch (error) {
      alert(alertMessagedeclarationFailed);
    }
  };

  const handleClosed = () => {
    setIsDeclarationView(false);
  };

  const actionList = [
    (data) => (
      <IconButton
        onClick={() => handleDeclarationLink(data)}
        style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', gap: '5px' }}
      >
        <EyeIcon style={{ width: '20px', height: '20px' }} />
        <Label color="primary" cursor="pointer">
          View
        </Label>
      </IconButton>
    ),
  ];

  const excelFormatData = extractData(tableData);
  const fileName = 'logRecords.xlsx';
  const columnConfig = [
    { header: 'Visitor Name', key: 'VisitorName', width: 30 },
    { header: 'Entity Name', key: 'Company', width: 30 },
    { header: 'premise Name', key: 'premiseName', width: 30 },
    { header: 'Geofence Name', key: 'Geofence', width: 30 },
    { header: 'Service Role', key: 'serviceRole', width: 30 },
    { header: 'Date', key: 'Date', width: 20 },
    { header: 'Entry Time', key: 'entryTime', width: 20 },
    { header: 'Exit Time', key: 'exitTime', width: 20 },
  ];
  if (query.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.logRecords" />
        </HeaderTitle>
        <TwoColumns style={{ gap: '10px' }}>
          <FilterMenuFieldV2 handleFilterParams={handleFilterParams} isOnlyDate={true} />
          {excelFormatData && (
            <IconButtonWithText
              text={<IntlMessages id="button.text.downloadExcel" />}
              icon={<DownloadIcon />}
              onClick={() => exportExcelFile(excelFormatData, fileName, columnConfig)}
            />
          )}
        </TwoColumns>
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={tableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={query?.data?.length || 0}
          actions={actionList}
        />
      </TableWrapper>
      {declarationData && (
        <DeclarationModal
          open={isDeclarationView}
          onClose={handleClosed}
          userData={declarationData}
        />
      )}
    </StyledContainer>
  );
};

export default CorporateLogRecords;
